import { atom } from 'jotai'
import { ExpenseFilter } from 'src/services/expenses'
import { UiFilterState } from 'src/hooks/filters/filters-helpers'

export const expenseFiltersAtom = atom<Partial<ExpenseFilter> | undefined>(undefined)

export const expenseUiFiltersAtom =
  atom<UiFilterState<Partial<ExpenseFilter | undefined>>>(undefined)
